<template>
  <div class="page-wrap">
    <!-- 操作栏 -->
    <el-card shadow="never" style="margin-bottom:16px">
      <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">新增管理员</el-button>
    </el-card>

    <el-card shadow="never">
      <el-table :data="tableData" border stripe v-loading="loading">
        <el-table-column type="index" width="60" label="#" />
        <el-table-column label="用户名" prop="username" width="160" />
        <el-table-column label="角色" width="120">
          <template #default="{ row }">
            <el-tag :type="row.role === 'ADMIN' ? 'danger' : 'primary'" size="small">
              {{ row.role === 'ADMIN' ? '超级管理员' : '教师' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="任教学科" min-width="100">
          <template #default="{ row }">
            <span v-if="row.role === 'TEACHER'">{{ subjectName(row.subjectId) }}</span>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template #default="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">
              {{ row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createdAt" width="170" />
        <el-table-column label="操作" width="160">
          <template #default="{ row }">
            <el-button type="text" @click="openEditDialog(row)">编辑</el-button>
            <el-button type="text" class="danger-text" @click="deleteAdmin(row)" v-if="row.role !== 'ADMIN'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑 Dialog -->
    <el-dialog :title="editMode ? '编辑管理员' : '新增管理员'" :visible.sync="dialogVisible" width="520px" @closed="resetForm">
      <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="90px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="editForm.username" placeholder="请输入用户名" :disabled="editMode && editForm.role !== 'TEACHER'" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="editForm.password" type="password" show-password
            :placeholder="editMode ? '不修改请留空' : '请输入密码'" />
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="editForm.role" style="width:100%" @change="onRoleChange">
            <el-option label="超级管理员" value="ADMIN" />
            <el-option label="教师" value="TEACHER" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="editForm.role === 'TEACHER'" label="任教学科">
          <el-select v-model="editForm.subjectId" placeholder="必选" filterable style="width:100%">
            <el-option v-for="s in subjects" :key="s.id" :label="s.name" :value="s.id" />
          </el-select>
        </el-form-item>
        <template v-if="editMode && editForm.role === 'TEACHER'">
          <el-divider content-position="left">讲义导出计费</el-divider>
          <el-form-item label="单次支付金额">
            <div class="custom-price-row">
              <el-switch v-model="editForm.useCustomPrice" active-text="专属价格" inactive-text="使用默认" />
              <el-input-number
                v-if="editForm.useCustomPrice"
                v-model="editForm.customPrice"
                :min="0.01"
                :max="99999"
                :step="0.1"
                :precision="2"
                style="width:180px;margin-left:12px"
              />
            </div>
            <span class="field-tip">默认价：¥{{ formatPrice(quotaHint.defaultPrice) }} / {{ quotaHint.defaultExportCount || 0 }} 次</span>
          </el-form-item>
          <el-form-item label="导出额度">
            <span class="quota-text">免费剩余 {{ quotaHint.freeRemaining || 0 }} 次 · 付费剩余 {{ quotaHint.paidBalance || 0 }} 次</span>
          </el-form-item>
          <el-form-item label="赠送导出次数">
            <el-input-number v-model="editForm.grantExportCount" :min="0" :max="9999" :step="1" style="width:180px" />
            <span class="field-tip">保存时累加到该教师付费余额，填 0 表示不赠送</span>
          </el-form-item>
        </template>
        <el-form-item label="状态">
          <el-switch v-model="editForm.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="禁用" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveAdmin">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../utils/request'

export default {
  name: 'SystemAdmin',
  data() {
    return {
      tableData: [],
      loading: false,
      dialogVisible: false,
      editMode: false,
      saving: false,
      editForm: { id: null, username: '', password: '', role: 'TEACHER', status: 1, subjectId: null, useCustomPrice: false, customPrice: 9.9, grantExportCount: 0 },
      quotaHint: { defaultPrice: null, defaultExportCount: 0, freeRemaining: 0, paidBalance: 0 },
      subjects: [],
      editRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        role: [{ required: true, message: '请选择角色', trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadList()
    this.loadSubjects()
  },
  methods: {
    subjectName(id) {
      if (id == null) return '—'
      const s = this.subjects.find(x => x.id === id)
      return s ? s.name : ('ID:' + id)
    },
    loadSubjects() {
      request.get('/dict', { params: { type: 'subject' } }).then(data => {
        this.subjects = data || []
      }).catch(() => {})
    },
    formatPrice(price) {
      const n = Number(price)
      return Number.isFinite(n) ? n.toFixed(2) : '—'
    },
    loadTeacherQuota(adminId) {
      request.get(`/export-billing/quota/${adminId}`).then(data => {
        this.quotaHint = data || {}
        const hasCustom = data && data.customPrice != null
        this.editForm.useCustomPrice = !!hasCustom
        this.editForm.customPrice = hasCustom ? Number(data.customPrice) : Number(data.defaultPrice || 9.9)
        this.editForm.grantExportCount = 0
      }).catch(() => {
        this.quotaHint = { defaultPrice: null, defaultExportCount: 0, freeRemaining: 0, paidBalance: 0 }
      })
    },
    onRoleChange() {
      if (this.editForm.role === 'ADMIN') {
        this.editForm.subjectId = null
        this.editForm.customPrice = null
        this.editForm.useCustomPrice = false
        this.editForm.grantExportCount = 0
      }
    },
    loadList() {
      this.loading = true
      request.get('/system/adminUser/list', { params: { page: 0, size: 100 } }).then(data => {
        this.tableData = data.content || []
      }).finally(() => { this.loading = false })
    },
    openAddDialog() {
      this.editMode = false
      this.editForm = { id: null, username: '', password: '', role: 'TEACHER', status: 1, subjectId: null, useCustomPrice: false, customPrice: 9.9, grantExportCount: 0 }
      this.quotaHint = { defaultPrice: null, defaultExportCount: 0, freeRemaining: 0, paidBalance: 0 }
      this.dialogVisible = true
    },
    openEditDialog(row) {
      this.editMode = true
      this.editForm = {
        id: row.id,
        username: row.username,
        password: '',
        role: row.role,
        status: row.status,
        subjectId: row.subjectId != null ? row.subjectId : null,
        useCustomPrice: false,
        customPrice: 9.9,
        grantExportCount: 0
      }
      if (row.role === 'TEACHER') {
        this.loadTeacherQuota(row.id)
      } else {
        this.quotaHint = { defaultPrice: null, defaultExportCount: 0, freeRemaining: 0, paidBalance: 0 }
      }
      this.dialogVisible = true
    },
    resetForm() {
      this.$refs.editForm && this.$refs.editForm.resetFields()
    },
    saveAdmin() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        if (this.editForm.role === 'TEACHER' && !this.editForm.subjectId) {
          this.$message.warning('教师账号必须选择任教学科')
          return
        }
        this.saving = true
        const payload = {
          username: this.editForm.username,
          password: this.editForm.password,
          role: this.editForm.role,
          status: this.editForm.status,
          subjectId: this.editForm.subjectId
        }
        const req = this.editMode
          ? request.put(`/system/adminUser/${this.editForm.id}`, payload)
          : request.post('/system/adminUser', payload)
        req.then(() => {
          if (this.editMode && this.editForm.role === 'TEACHER') {
            return request.put(`/export-billing/quota/${this.editForm.id}`, {
              customPrice: this.editForm.useCustomPrice ? this.editForm.customPrice : null,
              grantExportCount: this.editForm.grantExportCount || 0
            })
          }
          return null
        }).then(() => {
          this.$message.success(this.editMode ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.loadList()
        }).catch(() => {}).finally(() => { this.saving = false })
      })
    },
    deleteAdmin(row) {
      this.$confirm(`确认删除管理员 "${row.username}"？`, '警告', { type: 'warning' }).then(() => {
        request.delete(`/system/adminUser/${row.id}`).then(() => {
          this.$message.success('已删除')
          this.loadList()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.danger-text { color: #ff4d4f; }
.field-tip { display: block; margin-top: 6px; color: #9ca3af; font-size: 12px; line-height: 1.5; }
.custom-price-row { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.quota-text { color: #374151; font-size: 13px; }
</style>
